
        import Symbol from "../../../svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-material-my_location",
  "use": "icon-material-my_location-usage",
  "viewBox": "0 -960 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\" id=\"icon-material-my_location\"><path d=\"M447.37-36.26v-75Q309.89-125.5 217.58-217.82q-92.32-92.31-106.32-229.55h-75v-65.26h75q14.24-137.48 106.56-229.79 92.31-92.32 229.55-106.32v-75h65.26v75q137.24 14 229.55 106.32 92.32 92.31 106.56 229.79h75v65.26h-75q-14 137.24-106.32 229.55-92.31 92.32-229.79 106.56v75zm32.59-141.89q124.32 0 213.11-88.74 88.78-88.75 88.78-213.07t-88.74-213.11q-88.75-88.78-213.07-88.78t-213.11 88.74q-88.78 88.75-88.78 213.07t88.74 213.11q88.75 88.78 213.07 88.78M480-330q-63 0-106.5-43.5T330-480t43.5-106.5T480-630t106.5 43.5T630-480t-43.5 106.5T480-330m-.09-65.5q35.7 0 60.14-24.36 24.45-24.36 24.45-60.05 0-35.7-24.36-60.14-24.36-24.45-60.05-24.45-35.7 0-60.14 24.36-24.45 24.36-24.45 60.05 0 35.7 24.36 60.14 24.36 24.45 60.05 24.45M480-480\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-material-my_location"/>
                </svg>
            );
        };

        Icon.id = "icon-material-my_location";

        export default Icon;
    